import Password from "@/assets/icon/Password";
import EditNote from "@/assets/icon/EditNote";
import IMenuItem from "@/interfaces/Props/IMenuItem";

const profileItems: Array<IMenuItem> = [
  {
    id: "profile",
    title: "MENU_PROFILE_TITLE",
    type: "item",
    icon: <EditNote color="primary" />,
    url: "profile",
    tag: "profile",
    children: [],
  },
  {
    id: "edit_password",
    title: "MENU_EDIT_PASSWORD_TITLE",
    type: "item",
    icon: <Password color="primary" />,
    url: "edit_password",
    tag: "edit_password",
    children: [],
  },
];

export default profileItems;
